import gql from 'graphql-tag';

const MOBILE_PROCEDURE_FRAGMENT = gql`
	fragment mobileProcedure on CompanyDocument {
		id
		title
		contentHtml
		format
		version
		publishedAt
		responsibleEmployee {
			id
			firstName
			lastName
			preferredName
			personalEmail
		}
	}
`;

export const GET_MOBILE_PROCEDURES = gql`
	query getMobileProcedureDocuments($page: Int, $perPage: Int, $query: String) {
		getMobileProcedureDocuments(page: $page, perPage: $perPage, query: $query) {
			items {
				...mobileProcedure
			}
			count
		}
	}
	${MOBILE_PROCEDURE_FRAGMENT}
`;

export const GET_MOBILE_PROCEDURE = gql`
	query getMobileProcedureDocument($id: ID!) {
		getMobileProcedureDocument(id: $id) {
			...mobileProcedure
		}
	}
	${MOBILE_PROCEDURE_FRAGMENT}
`;
